module.exports = __webpack_public_path__ + "static/media/particles.688c3288.webm";